/**
 * Created by Ivan on 25.09.2026
 */

const getPiggyBankNudgeDay = function () {
    return cleverapps.extractDateFromDateTime(Date.now());
};

Placements.ENTRIES["piggyBankFullNudge"] = {
    throttled: true,

    type: Placements.FREE_FOCUS_MAIN,

    filter: function () {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_PIGGY_BANK);
        return mission && mission.logic.isFull() && mission.logic.nudgeDay !== getPiggyBankNudgeDay();
    },

    action: function () {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_PIGGY_BANK);
        mission.logic.markNudge(getPiggyBankNudgeDay());

        cleverapps.metrics.logEvent(`${cleverapps.EVENTS.PIGGY_BANK}_nudge`);

        cleverapps.focusManager.display({
            focus: "PiggyBankFullNudge",
            action: function (f) {
                new PiggyBankWindow(mission);
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }
};
